/* eslint-disable react/prop-types */ // TODO: add props
import { useRef } from 'react';
import KeyCapture from 'edrolo/domains/app/side-effects/KeyCapture';
import urlResolver from 'edrolo/utils/URLResolver';
import { CourseSelector } from 'core/components';

const CourseJumper = ({
  selected,
  instanceId = 'course-jumper',
  placeholder = 'Jump to course',
}) => {
  const selectRef = useRef(null);

  const handleChangeCourse = (selectedOption) => {
    const courseId = selectedOption?.course_id;

    if (courseId) {
      const url = urlResolver.reverse('course', { courseId });

      global.analytics.track('used course jumper', {
        courseId,
        url,
      });
      window.location = url;
    }
  };

  return (
    <>
      <KeyCapture
        sequence="alt+j"
        onCapture={() => {
          selectRef.current.focus();
        }}
        block
      />
      <CourseSelector
        selected={selected}
        placeholder={placeholder}
        onChange={handleChangeCourse}
        instanceId={instanceId}
        selectRef={selectRef}
      />
    </>
  );
};

export default CourseJumper;
